<template>
  <div class="teen-page teen13">
    <div class="header">
      <h1>中医：传统医学的智慧</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_13.png" alt="中医">
        <div class="caption">中医，中国传统医学的瑰宝</div>
      </div>

      <h2>一、 中医的起源</h2>
      <p>中医是中国传统医学的重要组成部分，起源于远古时期。早在春秋战国时期，中医理论就已经形成体系。《黄帝内经》是中医理论的奠基之作。</p>

      <h2>二、 核心理论</h2>
      <p>中医的核心理论包括阴阳学说、五行学说、气血津液理论等。中医认为人体是一个有机整体，人与自然也是一个整体。疾病的发生是阴阳失衡的结果。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_13.png" alt="中草药">
        <div class="caption">中草药，中医治疗的重要手段</div>
      </div>

      <h2>三、 治疗方法</h2>
      <p>中医的治疗方法多种多样，包括中药、针灸、推拿、拔罐、食疗等。其中，中药是最常用的治疗手段，通过配伍使用各种草药来调理身体。</p>

      <h2>四、 中医的优势</h2>
      <p>中医注重整体调理，强调"治未病"，即预防疾病的发生。它在治疗慢性病、疑难杂症等方面具有独特的优势。</p>

      <div class="quote-box">
        "上医治未病，中医治欲病，下医治已病。" —— 《黄帝内经》
      </div>

      <h2>五、 现代发展</h2>
      <p>如今，中医正在走向世界。中国政府大力扶持中医药事业，中医的疗效也得到了国际社会的认可。中西医结合正在成为未来医学发展的重要方向。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen13'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #e8f5e9;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #2d5a27 0%, #4a7c59 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #2d5a27;
  border-bottom: 2px solid #8eb057;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e8f5e9;
  padding: 20px;
  border-left: 4px solid #2d5a27;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>